module.exports = __webpack_public_path__ + "img/IMG_7039.ea9b5af5.webp";